module.exports = __webpack_public_path__ + "static/bankOpening-231390f179e22005be3d5bd28dec8de9.jpg";